export default __webpack_public_path__ + "static/ai-hero-171ae40e9fbdcdf0c4eb62e551ebdb5b.webm";